import $ from 'jquery';
import product from '../api/product';

const ccChart = {
    updateChartPrices: function() {
        $('#ccModal table tr:last td').each(function(index, element) {
            var $cell = $(element),
                prodid = $cell.data('prodid');
            if (prodid !== undefined) {
                product.getProductClassWithAttributes(prodid).done(function(data) {
                    var price = data.Content.Price.substr(data.Content.Price.lastIndexOf('$') + 1);
                    $cell.html('$' + (price / 28).toFixed(2));
                });
            }
        });
    }
};
export default ccChart;
